<p-messages [key]="CustomMessageKey.top_fixed"></p-messages>
<p-toast [key]="CustomMessageKey.top_overlay"></p-toast>
<router-outlet></router-outlet>
<div class="flex w-full justify-content-center loading-screen" *ngIf="pageLoading">
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>
<app-error-message></app-error-message>
<app-success-message></app-success-message>
